import { render } from "./Loan_Securities.vue?vue&type=template&id=0f97c7f6"
import script from "./Loan_Securities.vue?vue&type=script&lang=js"
export * from "./Loan_Securities.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__